<template>
  <div
    class="ui-expand-indicator inline-flex items-center justify-center align-middle"
    :class="{ expanded }"
  >
    <UIIcon class="text-md">
      <v-icon>{{ icon }}</v-icon>
    </UIIcon>
  </div>
</template>

<script lang="ts" setup>
import UIIcon from '../ui-icon/UIIcon.vue';

interface Props {
  expanded?: boolean;
  icon?: string;
}

withDefaults(defineProps<Props>(), {
  expanded: true,
  icon: 'mdi-chevron-down',
});
</script>

<style scoped lang="scss">
.ui-expand-indicator {
  transition: transform 0.2s;
}

.expanded {
  transform: rotate(-180deg);
}
</style>
